<template >
<div
  class="info-panel"
  :class="{ reverse: reverse, 'link-panel': link }"
  @click="handleClickEvent">
  <BCard
    :noBody="false"
    class="overflow-hidden">
    <BRow
      :noGutters="false">
      <BCol
        v-if="includeImage"
        md="4">
        <slot name="image">
          <BCardImg
            :src="src"
            class="rounded-0">
          </BCardImg>
        </slot>
      </BCol>
      <BCol md="8">
        <BCardBody>
          <BCardText>
            <slot>
            </slot>
          </BCardText>
        </BCardBody>
      </BCol>
    </BRow>
  </BCard>
</div>
</template>

<script>
//
import {
  BCard,
  BImg,
  BCardBody,
  BCardText,
  BLink,
  BContainer,
  BRow,
  BCol,
} from 'bootstrap-vue'

export default {
  name: 'InfoPanel',
  props: {
    reverse: {
      type: Boolean,
      default: false
    },
    img: {
      type: String,
     // default: 'fieldwork.jpg'
    },
    includeImage: {
      type: Boolean,
      default: true,
    },
    link: {
      type: String,
    }
  },
  data() {
    return {};
  },
  components: {
    'b-link': BLink,
    'b-card': BCard,
    'b-img': BImg,
    'b-card-text': BCardText,
    'b-card-body': BCardBody,
    'b-container': BContainer,
    'b-row': BRow,
    'b-col': BCol,
  },
  created() {},
  watch: {},
  computed: {
    src(){
      if(!this.includeImage) return;
      try{
        return require(`@/assets/img/${this.img}`);
      } catch(err){
        let i = Math.round(Math.random()*100+1)
        return `https://picsum.photos/400/400/?image=${i}`
      }
    }
  },
  methods: {
    handleClickEvent(){
      if(!this.link) return;
      this.$router.push(`${this.link}`);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';
.info-panel  {
  margin: 1rem auto;
  max-width: 70rem;

  &.reverse {
    .card-body > .row {
      flex-direction: row-reverse;
    }
  }

  &.link-panel {
    cursor: pointer;
    &:hover {
      @include shadow;
    }
  }

}
</style>
